/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import autobind from 'class-autobind';
import { fetchJSON } from '../../support/Fetch';
import PreviewImage from './PreviewImage';
import LoadingIndicator from '../uiold/LoadingIndicator';
import { toPreviewURL } from '../../support/helpers/Files';

type Props = {
  file: {
    [key: string]: any;
  };
};

type State = {
  isLoading: boolean;
  showError: string;
  imageURL: string;
};

class PreviewDocument extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    autobind(this);

    this.state = {
      isLoading: true,
      showError: '',
      imageURL: '',
    };
  }

  componentDidMount() {
    this._fetchPreviewURL();
  }

  // TODO: The logic here is pretty much the same as that of Thumbnail.tsx; Can
  // we abstract this out in some way?
  _fetchPreviewURL() {
    let file = this.props.file;
    let url = `/api/files/preview/${file.id}`;
    fetchJSON(url, this._onFetchResponse);
  }

  _onFetchResponse(
    error: Error | null | undefined,
    data: {
      [key: string]: any;
    },
  ) {
    if (error) {
      this.setState({ showError: error.message });
    } else if (data.error) {
      this.setState({ showError: data.error });
    } else if (data.retry_after) {
      setTimeout(this._fetchPreviewURL, data.retry_after * 1000);
    } else {
      this.setState({
        isLoading: false,
        imageURL: toPreviewURL(data.url),
      });
    }
  }

  render() {
    if (this.state.showError) {
      return <p className="text-danger">{this.state.showError}</p>;
    }
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }
    return <PreviewImage src={this.state.imageURL} />;
  }
}

export default PreviewDocument;
